const $ = window.jQuery;
const $window = window.$window || $(window);

const Hamburger = {

    init () {
        var $module = $('.image-drawer .arrow');
        if (!$module.length)
            return;

        $module.on('click', function(){
          $('.image-drawer').toggleClass('open');
        });

    }

};

export default Hamburger;